module.exports = __webpack_public_path__ + "static/img/popup_save.704e3ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/customer/duschking-configurator/shower_tray/popup_save.png
// module id = zJdm
// module chunks = 12